// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__23bE5","search":"Settings_search__3sP8_","filter":"Settings_filter__2ET3F"};